/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */

import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import { fetchAndHandleResponse } from "../../../../utils";
import {
    ACTIVE_STATUS,
    ERROR_STATUS,
    NONE_STATUS
} from "../../../../../../components/response-loading/redux/response-loading-redux";

export const processResponse = (responseBody, dispatch, params) => {
    const { drugType, documentId, page_name } = params;
    if (responseBody) {
        dispatch(
            saveNeoPedMonograph({
                monograph: responseBody,
                page_name,
                drugType,
                documentId
            })
        );
    }
};

export const fetchAndSaveMonograph = createAsyncThunk('neoped_monograph/fetchMonograph', async (params, {
    dispatch,
    rejectWithValue
}) => {
    return await fetchAndHandleResponse(params, dispatch, rejectWithValue, processResponse);
});

const initialState = {
    neofax: {
        status: NONE_STATUS,
        error: null,
        monograph: {}
    },
    pediatrics: {
        status: NONE_STATUS,
        error: null,
        monograph: {}
    },
    citationId: ''
}

const neopedMonographSlice = createSlice({
    name: 'neoped_monograph_page',
    initialState: initialState,
    reducers: {
        saveNeoPedMonograph: (state, action) => {
            const { monograph, drugType } = action.payload;
            state[drugType].monograph = monograph;
        },
        saveCitationId: (state, action) => {
            state.citationId = action.payload;
        },
        clearNeoPedMonographState: (state) => {
            return initialState;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAndSaveMonograph.pending, (state, action) => {
                const drugType = action.meta.arg?.drugType;
                state[drugType].status = ACTIVE_STATUS;
            })
            .addCase(fetchAndSaveMonograph.fulfilled, (state, action) => {
                const drugType = action.meta.arg?.drugType;
                state[drugType].status = NONE_STATUS;
                state[drugType].error = null;
            })
            .addCase(fetchAndSaveMonograph.rejected, (state, action) => {
                const drugType = action.meta.arg?.drugType;
                state[drugType].status = ERROR_STATUS;
                state[drugType].error = action.payload;
            });
    }
});

export const { saveNeoPedMonograph, saveCitationId, clearNeoPedMonographState } = neopedMonographSlice.actions;
export const selectNeopedMonograph = (state) => state.neoped_monograph_page;
export const selectCitationId = (state) => state.neoped_monograph_page.citationId;

export default neopedMonographSlice.reducer;
